<template>
    <div class="loc-1">
        <div id="container1" style="width: 100%; height: 700px"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            map: null,
            markers: [],
        }
    },
    async mounted() {
        await this.loadMap()
    },
    methods: {
        loadMap() {
            return new Promise((resolve, reject) => {
                this.map = new AMap.Map("container1", {
                    resizeEnable: true,
                    zoom: 9,
                })
                resolve()
            })
        },
    },
}
</script>

<style lang="less" scoped>
.loc-1 {
    width: 98%;
    margin-left: 2%;
}
</style>
